<script>
  import { fade, fly } from "svelte/transition";
  import { cubicIn } from "svelte/easing";
  export let mostrarLogo;
</script>

<style>
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100vh;
    background-color: white;
  }

  svg {
    position: fixed;
    z-index: 10;
    left: 15%;
    top: 15%;
    width: 90%;
  }

  @media (min-width: 768px) {
    svg {
      width: 50%;
      left: 30%;
    }
  }
</style>

{#if mostrarLogo}
  <div out:fly={{ y: -20, duration: 800 }} />
  <svg viewBox="0 0 65 45" xmlns="http://www.w3.org/2000/svg">
    <g
      aria-label="ISOTIPO"
      fill="#1aaded"
      fill-rule="evenodd"
      in:fade={{ duration: 600 }}
      out:fly={{ x: -30 }}>
      <ellipse cx="6.132" cy="10.121" rx=".367" ry=".353" />
      <ellipse cx="5.809" cy="11.571" rx=".614" ry=".591" />
      <ellipse cx="5.176" cy="13.511" rx=".91" ry=".875" />
      <ellipse cx="4.488" cy="15.981" rx="1.144" ry="1.1" />
      <ellipse cx="4.426" cy="19.031" rx="1.389" ry="1.337" />
      <ellipse cx="5.333" cy="22.351" rx="1.512" ry="1.454" />
      <ellipse cx="6.49" cy="25.391" rx="1.32" ry="1.27" />
      <ellipse cx="7.367" cy="28.211" rx="1.217" ry="1.171" />
      <ellipse cx="7.542" cy="30.801" rx="1.008" ry=".97" />
      <ellipse cx="6.93" cy="33.081" rx=".77" ry=".741" />
      <ellipse cx="6.168" cy="34.781" rx=".551" ry=".53" />
    </g>
    <g aria-label="Columna" transition:fly={{ x: 20 }}>
      <path
        d="M13.646 19.58q-.412.597-1.053.962-.631.365-1.499.365-.825
        0-1.516-.373-.682-.382-1.078-1.054t-.396-1.518q0-.87.387-1.543.388-.68
        1.036-1.053.65-.374 1.399-.374.606 0
        1.07.216.471.216.791.606l.009-.706h.783v1.85l-.556.05q-.606-1.327-1.97-1.327-.548
        0-1.02.282-.463.274-.75.796-.278.515-.278 1.195 0 .647.278
        1.162.278.506.75.796.48.29 1.061.29.682 0
        1.154-.29.48-.29.834-.796zM16.506 20.91q-.581
        0-1.087-.257-.505-.258-.808-.73-.295-.473-.295-1.079
        0-.614.295-1.078.303-.473.808-.73t1.087-.258q.573 0
        1.07.258.505.257.808.73t.303 1.078q0 .606-.294
        1.079-.295.472-.8.73-.498.257-1.087.257zm0-.656q.379 0
        .682-.174.303-.174.472-.49.177-.323.177-.746t-.177-.738q-.169-.324-.472-.498t-.682-.174q-.581
        0-.96.39-.37.381-.37 1.02t.37 1.029q.379.381.96.381zM21.806
        20.146v.655h-2.628v-.655h.884v-4.38h-.884v-.656h1.71v5.036zM27.412
        20.721q-.286.158-.632.158-.395
        0-.64-.232-.244-.233-.278-.664-.42.456-.825.688-.404.233-.85.233-.658
        0-1.02-.432-.354-.431-.354-1.269v-1.66h-.792v-.655h1.618v2.29q0
        .465.193.722.203.249.64.249.65 0
        1.382-.805v-1.8h-.725v-.656h1.55v2.904q0 .406.287.406.168 0
        .26-.066zM36.41
        20.146v.655h-2.325v-.655h.716v-1.668q0-.431-.193-.68-.194-.249-.582-.249-.345
        0-.707.224t-.708.639v1.734h.725v.655H31.06v-.655h.725v-1.668q0-.431-.202-.68-.202-.249-.59-.249-.345
        0-.707.232-.363.224-.716.647v1.718h.732v.655h-2.45v-.655h.892v-2.597h-.893v-.655h1.719v.854q.37-.456.808-.705.438-.249.91-.249.48
        0 .8.266.329.257.455.763.379-.49.825-.755.455-.274.944-.274.615 0
        .96.431.354.424.354 1.228v1.693zM42.556
        20.146v.655h-2.341v-.655h.733v-1.618q0-.456-.236-.714-.228-.265-.657-.265-.733
        0-1.55.912v1.685h.733v.655h-2.451v-.655h.893v-2.597h-.893v-.655h1.718v.92q.472-.514.901-.763.438-.257.935-.257.682
        0 1.053.431.37.432.37 1.278v1.643zM47.635 20.701q-.278.166-.649.166-.312
        0-.53-.174-.211-.182-.295-.514-.843.738-1.668.738-.581
        0-.986-.324t-.404-.904q0-.398.228-.688.227-.299.606-.448.387-.158.834-.158.379
        0 .699.075.32.066.657.199v-.365q0-.423-.286-.622-.287-.2-.75-.2-.657
        0-1.584.357l-.168-.63q.994-.415 1.853-.415.817 0 1.263.398.455.39.455
        1.145v1.435q0 .407.295.407.126 0 .261-.067zm-3.715-1.053q0
        .282.228.44.227.149.556.149.286 0
        .656-.15.371-.149.767-.44v-.439q-.573-.199-1.213-.216-.413
        0-.707.175-.287.166-.287.48z" />
    </g>
    <g
      aria-label="VITAE"
      stroke-width=".352"
      stroke="none"
      fill="#1aaded"
      in:fade={{delay: 400, duration: 900 }}
      out:fly={{x: -30}}>
      <path
        d="m18.3 24.324h-1.06l-2.754
        4.933h-0.867l-2.733-4.933h-1.06v-1.094h3.681v1.095h-0.928l1.58 3.096
        1.52-3.096h-1.03v-1.095h3.651zm3.487
        0v3.726h1.152v1.095h-3.947v-1.095h1.142v-3.726h-1.142v-1.094h3.947v1.095zm9.303-1.104v2.278h-1.438v-1.182h-1.489v3.726h1.112v1.095h-3.885v-1.095h1.121v-3.726h-1.499v1.182h-1.438v-2.278zm8.224
        4.829v1.095h-3.569v-1.095h1.03l-0.388-0.863h-2.56l-0.377
        0.863h1.132v1.095h-3.498v-1.095h0.826l1.877-3.735h-0.724v-1.087h4.232v1.087h-0.714l1.887
        3.735zm-3.354-1.829-0.846-1.906h-0.01l-0.847
        1.906zm9.814-0.792v-1.104h-3.03v1.44h1.071v-0.681h1.214v2.346h-1.214v-0.682h-1.07v1.303h3.029v-1.104h1.437v2.199h-7.22v-1.095h1.132v-3.726h-1.132v-1.096h7.22v2.2z" />
    </g>
  </svg>
{/if}